import { getRouteApi } from '@tanstack/react-router'
import { PageSection } from 'ui/components/Page'
import { LicensingQuestionnaire } from '~bank-annual-review/components/LicensingQuestionnaire'

import { s } from './styles'

export const Licensing = (): JSX.Element | null => {
  const data = getRouteApi('/_app/annual-review/detail/$companyId/$id/print').useLoaderData()

  if (!data.licensingItems) return null

  return (
    <PageSection title="Licensing">
      <s.Table>
        <thead>
          <tr>
            <s.Th>License Type</s.Th>
            <s.Th>Issue Date</s.Th>
            <s.Th>Expiration Date</s.Th>
            <s.Th>Number</s.Th>
            <s.Th>Location</s.Th>
          </tr>
        </thead>
        <tbody>
          {data.licensingItems.map((license, index) => (
            <tr key={index}>
              <s.Td>{license.type}</s.Td>
              <s.Td>
                <>{license.issueDate}</>
              </s.Td>
              <s.Td>
                <>{license.expirationDate}</>
              </s.Td>
              <s.Td>{license.licenseNumber}</s.Td>
              <s.Td>{license.location}</s.Td>
            </tr>
          ))}
        </tbody>
      </s.Table>
      <LicensingQuestionnaire data={data} />
    </PageSection>
  )
}
